import client from '@/config/directus.api';

const COLLECTION = 'bb_widget_positions';

/**
 * Get Positions
 *
 */
export function getPositions() {
  try {
    const response = client.getItems(COLLECTION, {
      fields: ['*']
    });

    return response;
  } catch (error) {
    throw new Error(error);
  }
}

/**
 * Get Position by id
 *
 * @param {int} id
 */
export function getPositionById(id) {
  try {
    const response = client.getItems(COLLECTION, {
      fields: ['*'],
      filter: {
        id
      }
    });

    return response;
  } catch (error) {
    throw new Error(error);
  }
}
